// DensityPicker — 밀도 모드 3-way 세그먼트 토글.
// 컴팩트 / 기본 / 편안 중 하나를 선택한다.
// useDensity 훅을 직접 받거나, 내부에서 사용.

import { type DensityMode, DENSITY_OPTIONS } from '../utils/density';

interface DensityPickerProps {
  /** 현재 선택된 밀도 모드 */
  value: DensityMode;
  /** 밀도 변경 핸들러 */
  onChange: (value: DensityMode) => void;
  /** 레이블 표시 여부 (기본: true) */
  showLabel?: boolean;
}

export function DensityPicker({ value, onChange, showLabel = true }: DensityPickerProps) {
  return (
    <div className="density-picker" role="group" aria-label="밀도 모드 선택">
      {showLabel && (
        <span className="density-picker__label">화면 밀도</span>
      )}
      <div className="density-picker__options">
        {DENSITY_OPTIONS.map((opt) => {
          const isActive = value === opt.value;
          return (
            <button
              key={opt.value}
              type="button"
              role="radio"
              aria-checked={isActive}
              aria-label={`${opt.label} — ${opt.description}`}
              className={[
                'density-picker__option',
                isActive ? 'density-picker__option--active' : '',
              ].join(' ').trim()}
              onClick={() => onChange(opt.value)}
            >
              {opt.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
